import { useEffect, useRef } from "react";

const JitsiMeeting = ({ 
	roomName, 
	displayName 
}: { 
	roomName: string, 
	displayName: string 
}) => {
  const jitsiContainer = useRef(null);

  useEffect(() => {
    // Evita crear múltiples instancias si el componente se recarga
    if (!(window as any).JitsiMeetExternalAPI) return;

    const domain = "meet.jit.si";
    const options = {
      roomName,
      parentNode: jitsiContainer.current,
      width: "100%",
      height: "100%",
      configOverwrite: {
        disableDeepLinking: true, // evita redirigir a la app móvil
      },
      interfaceConfigOverwrite: {
        SHOW_JITSI_WATERMARK: false,
        SHOW_BRAND_WATERMARK: false,
        TOOLBAR_BUTTONS: [
          "microphone",
          "camera",
          "chat",
        //   "raisehand",
        //   "tileview",
          "hangup",
        ],
      },
      userInfo: { displayName },
    };

    const api = new (window as any).JitsiMeetExternalAPI(domain, options);

    api.addEventListener("videoConferenceJoined", () => {
      console.log("Entró a la sala:", roomName);
    });

    return () => api.dispose(); // Limpia al salir del componente
  }, [roomName, displayName]);

  return (
    <div
      ref={jitsiContainer}
      style={{
        width: "100%",
        height: "100vh",
        backgroundColor: "#000",
      }}
    />
  );
};

export default JitsiMeeting;
